import { transformScanGroups } from 'src/apps/mobile-common/helpers/transformScanGroups';
import { SEVERITY_OPTIONS } from 'src/apps/mobile-sdk/pages/all-tesks/sections/header/MobileSdkTestsFilterDefinitions';
import { TMobileSdkTestFilterOptions } from 'src/apps/mobile-sdk/types/MobileSdkServiceTypes';
import { naturalSort } from 'src/common/helpers/DataFilterHelper';
import { formatFilterOptionsForEvSelect } from 'src/common/helpers/FormatHelper';

import { MobileSdkTestFilterOptionsQuery } from '../MobileSdkTestFilterOptions.generated';

export const transformMobileSdkTestFilterOptionsResults = (
	rawResults: MobileSdkTestFilterOptionsQuery
): TMobileSdkTestFilterOptions => {
	const { type_name_group_uniq_array: typeResults = [] } = rawResults?.filter_groups?.[0] ?? {};

	return {
		severities: SEVERITY_OPTIONS,
		types: formatFilterOptionsForEvSelect(
			(typeResults.filter((type) => type) as string[]).toSorted(naturalSort)
		),
		scans: transformScanGroups(rawResults)
	};
};
